import UserActionList from "./user-actions-list";
import UserActionItems from "./fields";

const UserAction = {
  List: UserActionList,
  Fields: UserActionItems
}

export default UserAction;